import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const SettingsPage = () => <Guide content={guides.settings} />
